import {
  MPCZ_REGISTER_COMPLAINT_REQUEST,
  MPCZ_REGISTER_COMPLAINT_SUCCESS,
  MPCZ_REGISTER_COMPLAINT_FAILURE,
  MPCZ_REGISTER_COMPLAINT_CLEAR,
  MPCZ_COMPLAINT_STATUS_REQUEST,
  MPCZ_COMPLAINT_STATUS_SUCCESS,
  MPCZ_COMPLAINT_STATUS_FAILURE,
  MPCZ_COMPLAINT_STATUS_CLEAR,
} from "../actions/mpczAction";

const initialState = {
  mpcz_register_complaint_loading: false,
  mpcz_register_complaint_data: null,
  mpcz_register_complaint_error: null,
  mpcz_complaint_status_loading: false,
  mpcz_complaint_status_data: null,
  mpcz_complaint_status_error: null,
};

const mpczReducer = (state = initialState, action) => {
  switch (action.type) {
    case MPCZ_REGISTER_COMPLAINT_REQUEST:
      return {
        ...state,
        mpcz_register_complaint_loading: true,
        mpcz_register_complaint_error: null,
      };
    case MPCZ_REGISTER_COMPLAINT_SUCCESS:
      return {
        ...state,
        mpcz_register_complaint_loading: false,
        mpcz_register_complaint_data: action.payload,
      };
    case MPCZ_REGISTER_COMPLAINT_FAILURE:
      return {
        ...state,
        mpcz_register_complaint_loading: false,
        mpcz_register_complaint_error: action.payload,
      };
    case MPCZ_REGISTER_COMPLAINT_CLEAR:
      return {
        ...state,
        mpcz_register_complaint_data: null,
        mpcz_register_complaint_error: null,
      };
    case MPCZ_COMPLAINT_STATUS_REQUEST:
      return {
        ...state,
        mpcz_complaint_status_loading: true,
        mpcz_complaint_status_error: null,
      };
    case MPCZ_COMPLAINT_STATUS_SUCCESS:
      return {
        ...state,
        mpcz_complaint_status_loading: false,
        mpcz_complaint_status_data: action.payload,
      };
    case MPCZ_COMPLAINT_STATUS_FAILURE:
      return {
        ...state,
        mpcz_complaint_status_loading: false,
        mpcz_complaint_status_error: action.payload,
      };
    case MPCZ_COMPLAINT_STATUS_CLEAR:
      return {
        ...state,
        mpcz_complaint_status_data: null,
        mpcz_complaint_status_error: null,
      };
    default:
      return state;
  }
};

export default mpczReducer;
